import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveImageCommand extends CommandBase {
    id: string;

    constructor(id: string) {
        super();
        this.id = id;
    }

    execute(data: RemoteConstantsModel): boolean {
        for (const key of Object.keys(data.images)) {
            if (key === this.id) {
                const fileName = data.images[key].fileName;
                data.archive.push({
                    fileName: fileName,
                    key: key
                });
            }
        }

        delete data.images[this.id];
        return true;
    }
}